import script from "./WordMatchGame.vue?vue&type=script&setup=true&lang=js"
export * from "./WordMatchGame.vue?vue&type=script&setup=true&lang=js"

import "./WordMatchGame.vue?vue&type=style&index=0&id=7e48adf2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7e48adf2"]])

export default __exports__